// @flow

/**
 * Export `metatags` entities.
 */

export const metatags = {
  about: {
    en: {
      description: 'Internacional regulated fintech company for cross-border swaps.',
      keywords: 'world-wide currency swap, self-regulation swaps, global escrow, currency matching, safe cross border swap',
      title: 'Wayfex - About us'
    },
    pt: {
      description: 'Fintech internacional regulada para swaps transfronteiriços.',
      keywords: 'swaps internacionais de divisas, swaps auto-regulados, depósitos globais, troca de divisas, swaps transfronteiriços seguros, pares de divisas',
      title: 'Wayfex - Sobre Nós'
    }
  },
  contacts: {
    en: {
      description: 'Get in touch',
      keywords: 'get in touch, contact, address',
      title: 'Wayfex - Contact us'
    },
    pt: {
      description: 'Contacte-nos',
      keywords: 'contacto, morada, email',
      title: 'Wayfex - Contactos'
    }
  },
  forAgents: {
    en: {
      description: 'Wayfex certified Agents act on behalf of fund holders to assure successful operations and earn a fee for every transaction.',
      keywords: 'agents, operation fees, swap fees, fees, transaction fees, certified agent, certification, referral agent, referral, referral fee',
      title: 'Wayfex Agents - Earn fees by managing Wayfex Operations'
    },
    pt: {
      description: 'Agentes Wayfex representam os detentores dos fundos e asseguram o sucesso das operações, ganhando uma fee por cada transação.',
      keywords: 'agentes, fees de operação, swap fees, comissão,  comissão de transacção, agente certificado, certificação, recomendação, comissão de recomendação',
      title: 'Agentes Wayfex - Ganhe comissões gerindo operações Wayfex'
    }
  },
  home: {
    en: {
      description: 'International Bank-to-Bank Currency Swaps.',
      keywords: 'kwanza, aoa, angola, usd, dollars, eur, euro, transfer abroad, fx, forex, local currency, funds, money, pairs, major, minor, crosses, legal, expats, swap, currency swap, global transfers',
      title: 'Wayfex - Enterprise Currency Swaps - Cross Border Swaps USD/EUR/AOA'
    },
    pt: {
      description: 'Swaps internacionais de divisas bancarizadas.',
      keywords: 'kwanza, aoa, angola,usd, dollars, eur, euro, transfer abroad, fx, forex, local currency, funds, money,, pairs, major, minor, crosses, legal, expats, swap, currency swap, global transfers',
      title: 'Wayfex - Swaps de divisas - Transações transfronteiriças USD/EUR/AOA'
    }
  },
  howItWorks: {
    en: {
      description: 'Set up an account and start transacting.',
      keywords: 'set up account, start transferring, how it works, process, find deal',
      title: 'Wayfex - How does it work?'
    },
    pt: {
      description: 'Crie uma conta e inicie uma operação.',
      keywords: 'criar conta, começar uma operação, como funciona, processo',
      title: 'Wayfex - Como funciona?'
    }
  },
  licensedRepresentatives: {
    en: {
      description: 'Wayfex Licensed representatives are organizations or individuals with full powers to operate on specific territories and able to manage Wayfex business model for specific currencies.',
      keywords: 'new market, new currency, more currencies, other currencies, all currencies, global swaps, licensed currencies, licensed currency, representative, licensed representative, global representative, cross border representative, agente, regulated, authorized compliance',
      title: 'Wayfex Licensed Representatives - Expand Wayfex to new currencies'
    },
    pt: {
      description: 'Os representantes licenciados Wayfex são organizações ou indivíduos com autorização para operar em territórios específicos e capazes de gerir operações Wayfex para divisas específicas.',
      keywords: 'novo mercado, nova divisa, outras divisas, outras moedas, swaps globais, swaps licenciados, representante licenciado, representante, agente, representante global, compliance, regulado, autorizado, representante estrangeiro',
      title: 'Representantes Licenciados Wayfex - Torne-se parceiro em novos territórios'
    }
  }
};



// WEBPACK FOOTER //
// ../src/core/entities/metatags.js